import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "CYGA EVENEMENT - Spectacles Pyrotechniques en France",
  description = "CYGA EVENEMENT, créateur de frissons. Spectacles pyrotechniques pour mariages, communes, événements et spectacles transportables partout en France. Expertise et passion depuis plus de 15 ans.",
  keywords = "spectacle pyrotechnique, feux d'artifice, mariage, événement, commune, spectacle transportable, pyrotechnie, France, CYGA",
  image = "https://www.cyga-evenement.fr/og-image.jpg",
  url = "https://www.cyga-evenement.fr",
  type = "website"
}) => {
  const siteTitle = "CYGA EVENEMENT";
  const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="CYGA EVENEMENT" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="theme-color" content="#1a1a1a" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "CYGA EVENEMENT",
          "image": image,
          "description": description,
          "url": url,
          "telephone": "+33-XXX-XXX-XXX",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "FR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "0",
            "longitude": "0"
          },
          "priceRange": "€€",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "09:00",
              "closes": "18:00"
            }
          ],
          "sameAs": [
            "https://www.facebook.com/cygaevenement",
            "https://www.instagram.com/cygaevenement"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
